/* IMPORT VUE */
import Vue from 'vue/dist/vue.common.js';
Vue.config.productionTip = false;

import EventBus from './assets/event-bus.js';

// DONUT - Donut Charts
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

// MOMENT
window.moment = require('moment');

// AXIOS
window.axios = require('axios');
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;

Vue.mixin({
	methods: {
		_getRandomNumber(max) {
			return Math.floor(Math.random() * max);
		},
		_scrollToTop() {
			window.scrollTo({top: 0, behavior: 'smooth'});
		},
		_getUrlSearch(sParam) {
			var sPageURL = window.location.search.substring(1),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;
			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');
				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined
						? true
						: decodeURIComponent(sParameterName[1]);
				}
			}
		},
		_togActive($this) {
			if ($this.classList.contains('active')) {
				$this.classList.remove('active');
			} else $this.classList.add('active');
		}
	}
});

export const app = new Vue({
	el: '#app',
	components: {
		Accordion: () => import('./components/accordion/_accordion.vue'),
		Blog: () => import('./components/blog/_blog.vue'),
		BlogRecentPosts: () => import('./components/blog-recent-posts/_blog-recent-posts.vue'),
		ExpandingText: () => import('./components/expanding-text/_expanding-text.vue'),
		InvestmentHistory: () => import('./components/investment-history/_investment-history.vue'),
		Slideshow: () => import('./components/slideshow/_slideshow.vue'),
		SearchForm: () => import('./components/search-form/_search-form.vue')
	},
	data() {
		return {
			showSearch: false,
			searchTerm: '',
			scrollyEventListener: {},
			mainMinHeight: 10,
			mobiNavOpen: false,
			hamburgerClass: '',
			slideShow: {
				speed: 8000
			},
			scrollOps: {
				vuescroll: {
					mode: 'native',
					wheelDirectionReverse: true
				},
				scrollPanel: {
					scrollingX: true,
					scrollingY: false,
				},
				rail: {},
				bar: {
					keepShow: true
				}
			},
			showSwirl: true,
			homeSwirl: false
		};
	},
	computed: {},
	methods: {
		togSearch() {
			this.showSearch = !this.showSearch;
			document.body.style.overflow = this.showSearch ? 'hidden' : null;
		},
		scrolly() {
			const vpTop = window.scrollY;
			const vpHeight = (window.innerHeight || document.documentElement.clientHeight);
			const vpBottom = vpHeight + vpTop;
			const scrollies = Array.from(document.getElementsByClassName('scrolly'));
			if (Array.isArray(scrollies) && scrollies.length) scrollies.forEach(scrolly => {
				let bounds = scrolly.getBoundingClientRect();
				let elTop = scrolly.offsetTop;
				let inFrame = (bounds.top < vpHeight) && (bounds.bottom > 0);
				let belowFrame = elTop >= vpBottom;
				let aboveFrame = bounds.bottom <= 0;
				if (inFrame) {
					scrolly.classList.add('in-frame');
					scrolly.classList.remove('below-frame');
					scrolly.classList.remove('above-frame');
				}
				if (belowFrame) {
					scrolly.classList.add('below-frame');
					scrolly.classList.add('going-up');
					scrolly.classList.remove('going-down');
					scrolly.classList.remove('in-frame');
					scrolly.classList.remove('above-frame');
				}
				if (aboveFrame) {
					scrolly.classList.add('above-frame');
					scrolly.classList.add('going-down');
					scrolly.classList.remove('going-up');
					scrolly.classList.remove('in-frame');
					scrolly.classList.remove('below-frame');
				}
			});
		},
		// getMainHeight() {
		// 	let headEl = document.getElementById('site-header');
		// 	let headBound = headEl.getBoundingClientRect();
		// 	let footEl = document.getElementById('site-footer');
		// 	let footBound = footEl.getBoundingClientRect();
		// 	this.mainMinHeight = `calc(100vh - ${headBound.height + footBound.height + 1}px)`
		// },
		mobiNavTog() {
			let ham = document.getElementById('hamburger');
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
			this.mobiNavOpen = !this.mobiNavOpen;
			if (this.mobiNavOpen) {
				ham.classList.add('active');
				ham.classList.remove('closed');
			} else {
				ham.classList.remove('active');
				ham.classList.add('closed');
			}
		},
		// mobiSubNav() {
		// 	document.addEventListener('click', function (e) {
		// 		if (!e.target.matches('.mobi-sub > a')) return;
		// 		e.preventDefault();
		// 		var $this = e.target.closest('.mobi-sub');
		// 		if ($this.classList.contains('active')) {
		// 			$this.classList.remove('active');
		// 		} else {
		// 			$this.classList.add('active');
		// 		}
		// 	}, false);
		// },
		checkTabs() {
			let checkTabs = Array.from(document.querySelectorAll('.tabs'));
			if (Array.isArray(checkTabs) && checkTabs.length) this.startTabs();
		},
		startTabs() {
			let tabbox = Array.from(document.querySelectorAll('.tabs'));
			let tabs = Array.from(document.querySelectorAll('.tabs .tab'));
			let tabContent = Array.from(document.querySelectorAll('.tabs .tab-box'));
			tabs[0].classList.add('active');
			tabContent[0].classList.add('active');
			tabs.forEach((tab, i) => {
				tab.addEventListener('click', e => {
					let closest = tab.closest('.tabs');
					closest.scrollIntoView({
						behavior: "smooth"
					});
					tabs.forEach(t => {
						t.classList.remove('active');
					});
					tab.classList.add('active');
					tabContent.forEach(tc => {
						tc.classList.remove('active');
					});
					tabContent[i].classList.add('active');
				});
			});
		},
		mobiSubNav() {
			let nodeList = Array.from(document.querySelectorAll('#main-nav .sub'));
			if (nodeList) {
				return nodeList.forEach((item, i) => {
					let btn = item.querySelector('a');
					if (btn) {
						btn.addEventListener('click', e => {
							// 1025px is "$desktop-min" in globals.scss. This is when the nav becomes a hamburger/mobile nav.
							// Only perform mobile menu logic when the nav is actually in mobile mode.
							const width = window.outerWidth;
							if (width < 1025) {
								e.preventDefault();
								if (item.classList.contains('active')) {
									item.classList.remove('active');
								} else item.classList.add('active');
							}
						});
					}
				});
			}
		},
		// mobiNav() {
		// 	let hamburger = document.getElementById('hamburger');
		// 	let mainNav  = document.getElementById('main-nav');
		// 	hamburger.addEventListener('click', e => {
		// 		this._togActive(hamburger);
		// 		this._togActive(mainNav);

		// 		if (!hamburger.classList.contains('active')) {
		// 			this.showSearch = false;
		// 		}
		// 	});
		// },
		mobiNav() {
			let hamburger = document.getElementById('hamburger');
			let mainNav = document.getElementById('main-nav');
			const bodyElement = document.body;
		  
			hamburger.addEventListener('click', e => {
			  this._togActive(hamburger);
			  this._togActive(mainNav);
		  
			  if (!hamburger.classList.contains('active')) {
				this.showSearch = false;
			  }
		  
			  // Add the "mobile-menu-open" class when the hamburger is active
			  if (hamburger.classList.contains('active')) {
				bodyElement.classList.add('mobile-menu-open');
			  } else {
				// Remove the "mobile-menu-open" class when the hamburger is not active
				bodyElement.classList.remove('mobile-menu-open');
			  }
			});
		},
		footNav() {
			let nodeList = Array.from(document.querySelectorAll('#foot-nav .sub'));
			if (nodeList) {
				return nodeList.forEach((item, i) => {
					let btn = item.querySelector('a');
					if (btn) {
						btn.addEventListener('click', e => {
							e.preventDefault();
							if (item.classList.contains('active')) {
								item.classList.remove('active');
							} else item.classList.add('active');
						});
					}
				});
			}
		},
		setCSSVars() {
			const header = document.getElementById('header');
			const headerHeight = header.offsetHeight;
			document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
			const footer = document.getElementById('footer');
			const footerHeight = footer.offsetHeight;
			document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
			const footSoc = document.getElementById('foot-soc');
			const footSocWidth = footSoc.offsetWidth;
			document.documentElement.style.setProperty('--foot-soc-width', footSocWidth + 'px');
			const footPhone = document.getElementById('foot-phone');
			const footPhoneWidth = footPhone.offsetWidth;
			document.documentElement.style.setProperty('--foot-phone-width', footPhoneWidth + 'px');
		},
		startScrollX() {
			const scrollX = [...document.querySelectorAll('.scroll-x')];
			if (Array.isArray(scrollX) && scrollX.length) {
				scrollX.forEach(x => {
					x.addEventListener("wheel", (e) => {
						e.preventDefault();
						x.scrollLeft += e.deltaY;
					});
				});
			}
		},
		startScrollXY() {
			const scrollXY = [...document.querySelectorAll('.scroll-y')];
			if (Array.isArray(scrollXY) && scrollXY.length) {
				scrollXY.forEach(y => {
					y.addEventListener("wheel", (e) => {
						e.preventDefault();
						y.scrollTop += e.deltaY;
					});
				});
			}
		},
		startTestScroll() {
			const testScroller = [...document.querySelectorAll('.testimonial')];
			testScroller.forEach(ts => {
				const scrollBox = ts.querySelector('.scroll-x')
				const scrollLeft = ts.querySelector('.scroll-left');
				const scrollRight = ts.querySelector('.scroll-right');
				const dotsContainer = ts.querySelector('.dots-container');
				const tiles = ts.querySelectorAll('.tile');
				const tileWidth = ts.querySelector('.tile').offsetWidth + 20;
				const numTiles = tiles.length;
				let leftX = 0;
				let rightX = scrollBox.scrollWidth - scrollBox.offsetWidth;
				// Add dot navigation
				for (let i = 0; i < numTiles; i++) {
					const dot = document.createElement('span');
					dot.classList.add('dot');
					dot.setAttribute('data-index', i);
					dotsContainer.appendChild(dot);
					dot.addEventListener('click', () => {
						const index = parseInt(dot.getAttribute('data-index'));
						leftX = index * tileWidth;
						if (leftX > rightX) leftX = rightX;
						scrollBox.scrollTo({
							top: 0,
							left: leftX,
							behavior: 'smooth'
						});
					});
				}
				scrollLeft.addEventListener('click', (e) => {
					leftX -= tileWidth;
					if (leftX < 0) leftX = 0;
					console.log('leftX', leftX);
					scrollBox.scrollTo({
						top: 0,
						left: leftX,
						behavior: 'smooth'
					});
				});
				scrollRight.addEventListener('click', (e) => {
					leftX += tileWidth;
					if (leftX > rightX) leftX = rightX;
					console.log('leftX', leftX);
					scrollBox.scrollTo({
						top: 0,
						left: leftX,
						behavior: 'smooth'
					});
				});
			});
		},
		printPage() {
			// Call the print function of the browser
			window.print();
		  }
	},
	created() {
		this.scrollyEventListener.scroll = document.addEventListener('scroll', e => {
			this.scrolly();
		});
		this.scrollyEventListener.resize = window.addEventListener('resize', e => {
			this.scrolly();
		});
		this.scrolly();
	},
	mounted() {
		this.mobiNav();
		this.mobiSubNav();
		this.footNav();
		this.checkTabs();
		this.setCSSVars();
		this.startScrollX();
		this.startScrollXY();
		this.startTestScroll();
	},
	destroyed() {
		this.scrollyEventListener = {};
	}
});
